import React, { useEffect } from "react";

import { useModal } from "@common/components/Modal/Modal";
import LoginImage from "common/assets/images/chrome-extension-login.png";
import Paragraph from "common/components/Paragraph/Paragraph";
import * as Styled from "main/pages/shared/components/ChromeExtensionLoginDialog/ChromeExtensionLoginDialog.styles";

export const LOCAL_STORAGE_SRC = "shakebugs.src";

const ChromeExtensionLoginDialog = () => {
  const { Modal, modalProps, active, setActive } = useModal({ size: "narrow" });

  useEffect(() => {
    if (!active && localStorage.getItem(LOCAL_STORAGE_SRC) === "sdk") {
      setActive(true);
      localStorage.removeItem(LOCAL_STORAGE_SRC);
    }
  }, [active, setActive]);

  if (!active) return null;

  return (
    <Modal
      {...modalProps}
      heading={"Login successful"}
      buttonText={"OK"}
    >
      <Styled.Container>
        <Paragraph>
          {"You can close this tab and return to the page where you were trying to submit the ticket."}
        </Paragraph>
        <Styled.Image src={LoginImage} />
      </Styled.Container>
    </Modal>
  );
};

const rememberUrlSrcParam = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const srcParam: string | null = urlParams.get("src");
  if (srcParam) {
    localStorage.setItem(LOCAL_STORAGE_SRC, srcParam);
  } else {
    localStorage.removeItem(LOCAL_STORAGE_SRC);
  }
};

export { ChromeExtensionLoginDialog, rememberUrlSrcParam };
